import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React from 'react';
import { MobileAddButton } from 'shared/components/ui/mobile-add-button';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

import * as Styled from './mobile-add-goal-button.style';

export const MobileAddGoalButton = () => {
  const openPremiumDialog = useOpenPremiumDialog();
  const openCreateGoalDialog = useOpenCreateGoalDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();

  const onAdd = () =>
    createGoalAllowed ? openCreateGoalDialog({}) : openPremiumDialog();

  return (
    <Styled.Container>
      <MobileAddButton onClick={onAdd} />
    </Styled.Container>
  );
};
